import React, { Dispatch, SetStateAction, useCallback, useMemo, useState } from "react";
import {
    AppointmentTypes, AppointmentDate, ItemAppointment, onSelectDateCallback,
    ModalAppointmentCheckObj, AppointmentSartoria, AppointmentSartoriaOther, Optional,
    typeAppointmentSartoria, ModalMergeObj
} from "../../../Models/Types.ts";
import { parseDate } from "../../../Utils/StringFunctions.ts";
import ModalAppointmentCheck from "./ModalAppointmentCheck.tsx";
import Select, { SelectChangeEvent } from '@mui/material/Select';
import { OutlinedInput } from "@mui/material";
import MenuItem from '@mui/material/MenuItem';
import ModalAppointmentMerge from "./ModalAppointmentMerge.tsx";
import { RemoteAPI } from "../../../appointmentApi.tsx";
import Loader from "../../UI/Loader.tsx";
import { TileSelectedAppointment } from "../CheckCode.tsx";

const emptyModalAppointmentObj = { show: false, customerQuantity: 0, selectedType: 0 }

export enum TileAppointmentCheckDataLocation {
    INSTANCES,
    OTHER
}

interface TileAppointmentCheckProps {
    id: string,
    location: TileAppointmentCheckDataLocation,
    dataAppointment: AppointmentSartoria,
    selectedAppointmentDate: AppointmentDate | undefined,
    appointmentDates: Array<TileSelectedAppointment>,
    setAppointmentDate: (key: string, appointemnt: AppointmentDate | null, data: AppointmentSartoria) => void,
    setOthersAppointment: Dispatch<SetStateAction<Array<AppointmentSartoria>>>,
    othersAppointment: Array<AppointmentSartoriaOther>,
    othersAppointmentIndex: number,
    setInstances: Dispatch<SetStateAction<typeAppointmentSartoria | null>>
}

type OptionalProps = "setOthersAppointment" | "othersAppointment" | "setInstances" | "location" | "othersAppointmentIndex" | "appointmentDates"
type TileAppointmentCheckPropsMandatory = Optional<TileAppointmentCheckProps, OptionalProps>;

const TileAppointmentCheck: React.FC<TileAppointmentCheckPropsMandatory> = ({ id, dataAppointment, selectedAppointmentDate, setAppointmentDate, setOthersAppointment, othersAppointment, setInstances, location, othersAppointmentIndex, appointmentDates }) => {

    const [modalAppointment, setModalAppointment] = useState<boolean>(false)

    const [isLoading, setIsLoading] = useState<boolean>(false)

    const onSelectDate = useCallback(async (selectedDate: AppointmentDate | null) => {
        setAppointmentDate(id, selectedDate, dataAppointment);
        if (id.includes("brides") && othersAppointment && othersAppointment?.length === 1 && othersAppointment[0].items.length > 0) {
            setIsLoading(true)
            try {
                const people = othersAppointment[0].men + othersAppointment[0].women;
                const appointments = await RemoteAPI.fetchAppointments(AppointmentTypes.RETRY_OTHERS, othersAppointment[0].men, othersAppointment[0].women, selectedDate?.date);

                const sameDay = appointments.dates.find(date => date.date === selectedDate?.date);
                if (sameDay) {
                    if (sameDay.slots.find(slot => slot.start === selectedDate?.slots[0].start)) {
                        if (appointmentDates && !appointmentDates.find(item => item.id === "inst-additive-0")) {
                            setAppointmentDate("inst-additive-0", sameDay, othersAppointment[0])
                        }
                    }
                }
            } catch (error) {
                setIsLoading(false)
            }

        }
        setIsLoading(false)
        setModalAppointment(false)
    }, [id, appointmentDates])

    const stateContainer = useCallback((item: ItemAppointment) => {
        if (item.stato.toLowerCase() === "Prendere le Misure".toLowerCase()) {
            return <div className="container-state-appointment-icon">Per <div className="state-appointment"> <i className="fa-solid fa-ruler"></i>{item.stato} </div></div>
        } else if (item.stato.toLowerCase() === "Prova".toLowerCase()) {
            return <div className="container-state-appointment-icon">Per la <div className="state-appointment"> <i className="fa-solid fa-person"></i> {item.stato} </div></div>
        } else if (item.stato.toLowerCase() === "Prova con consegna".toLowerCase()) {
            return <div className="container-state-appointment-icon">Per la <div className="state-appointment"> <i className="fa-solid fa-person-dress"></i> {item.stato} </div></div>
        }
    }, [])

    return <>
        {isLoading && <div className="loader-overlap-container"><Loader /></div>}
        <div className="container-tile-appointment-retire">
            {dataAppointment.items.map((item, index) => <div key={`container-tile-appointment-retire-item-${index}`} className="tile-appointment-retire">
                <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                    {stateContainer(item)}
                </div>

                <div className="appointment-name-container">dell'abito da
                    <div /* className={"type-appointment-container " + ` type-${item.tipo}`} */>
                        {AppointmentTypes.toString(item.tipo)}
                    </div>{item.nome !== "" ? `di ${item.nome}` : ""} </div>
                <div>Contr. {item.nr_contratto} </div>

            </div>)}
            <div className={`container-button-appointment show-flex`}>
                <button id="button-date-appointment" className="button-date-appointment" onClick={() => setModalAppointment(true)}>
                    {selectedAppointmentDate === null || selectedAppointmentDate === undefined ?
                        <>
                            Seleziona data
                            <img
                                className="image-calendar" src="/calendario-appuntamenti/images/calendar-clock-icon_34472.webp" />
                        </>
                        :
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                gap: "2vw"
                            }}
                        >
                            <div>
                                <div>Appuntamento {AppointmentTypes.toString(dataAppointment.appointmentType)}</div>
                                <div>{parseDate(selectedAppointmentDate.date)}</div>
                                <div>{selectedAppointmentDate.slots[0].start}</div>
                            </div>
                            <img className='icon-modify' src='./Assets/pen_edit_icon_177296.webp' />
                        </div>
                    }
                </button>
            </div>
        </div>
        {modalAppointment && <ModalAppointmentCheck
            womanNumber={dataAppointment.women}
            manNumber={dataAppointment.men}
            customersQuantity={dataAppointment.women + dataAppointment.men}
            onSelectDate={onSelectDate}
            selectedType={dataAppointment.appointmentType}
            setVisibleModal={setModalAppointment}
        />}
    </>
}

export default TileAppointmentCheck